import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TTnaUpdateState } from './tna-updates.models';

export const getTnaUpdateState = (state: TPlani8State) => state.tnaUpdateState;

export const getTnaStepsList = createSelector(getTnaUpdateState, (state: TTnaUpdateState) => state.tnaOrderStepList);

export const getTnaStepDetails = createSelector(getTnaUpdateState, (state: TTnaUpdateState) => state.tnaOrderStep);

export const getUserPaginationOption = createSelector(
  getTnaUpdateState,
  (state: TTnaUpdateState) => state.userPaginationOption,
);
